import React, { useState, useEffect } from 'react';
import logoOliver from './img/Logo Oliver.png';
import './DashboardHeader.css';

const DashboardHeader = ({ title, logoUrl = null, onLogoClick = null, children }) => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < 640 : false
  );
  const [isDarkTheme, setIsDarkTheme] = useState(() =>
    typeof document !== 'undefined' && document.documentElement.classList.contains('theme-dark')
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setIsDarkTheme(document.documentElement.classList.contains('theme-dark'));
  }, []);
  useEffect(() => {
    const handleThemeUpdated = () => setIsDarkTheme(document.documentElement.classList.contains('theme-dark'));
    window.addEventListener('themeUpdated', handleThemeUpdated);
    return () => window.removeEventListener('themeUpdated', handleThemeUpdated);
  }, []);

  const logoSrc = logoUrl || (typeof window !== 'undefined' ? localStorage.getItem('sidebarLogo') : null) || logoOliver;

  return (
    <header className={`dashboard-header-sticky ${isDarkTheme ? 'theme-dark' : ''}`}>
      <div className="dashboard-header-inner">
        <div className="dashboard-header-left">
          {isMobile && (
            <img
              src={logoSrc}
              alt="Logo"
              className="dashboard-header-logo"
              onClick={onLogoClick ? (e) => { e.preventDefault(); onLogoClick(); } : undefined}
              style={onLogoClick ? { cursor: 'pointer' } : {}}
            />
          )}
          <h1 className="dashboard-header-title">{title}</h1>
        </div>
        {children && (
          <div className="dashboard-header-right">
            {children}
          </div>
        )}
      </div>
    </header>
  );
};

export default DashboardHeader;
